import { Component, OnInit } from '@angular/core';
import {MyPositionService} from "../../services/myPosition/my-position.service";
declare const Yiit;

@Component({
  selector: 'app-my-position',
  templateUrl: './my-position.component.html',
  styleUrls: ['./my-position.component.scss']
})
export class MyPositionComponent implements OnInit {

  public Yiit = Yiit;

  constructor(
    protected myPositionService: MyPositionService
  ) { }

  ngOnInit() {
  }

}
